import React from "react";

// A real React error boundary: catches errors thrown while rendering (including
// failed lazy-loaded chunks). It deliberately does not listen to window "error" /
// "unhandledrejection" events, which also fire for third-party scripts (chat widget,
// Google Translate) and stray promise rejections and used to blank the whole app.
class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ height: "100vh", justifyItems: "center", alignContent: "center" }}>
          <h1>Something went wrong. Please try again later.</h1>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
